import React from 'react';

import { GuidanceBox, H1, Text } from '@betterment/samba-react';

import { Maybe, MessageCtaLink, MessageCtaModal } from '../../graphql/schema';
import MessageCta from '../../Shared/components-v2/message-box/message-cta';

interface Props {
  cta?: MessageCtaLink | MessageCtaModal;
  title?: Maybe<string>;
  body: string;
}

const MessageGuidanceBox: React.FC<Props> = ({ cta, title, body }) => {
  return (
    <GuidanceBox variant={title ? 'a' : 'b'} css={{ maxWidth: 'none' }}>
      <GuidanceBox.Icon />
      {title && (
        <GuidanceBox.Header>
          <H1 variant="title100" css={{ textWrap: 'auto' }}>
            {title}
          </H1>
        </GuidanceBox.Header>
      )}
      <GuidanceBox.Content
        css={{
          display: 'grid',
          gap: 'space.100',
        }}
      >
        <Text variant="text50">{body}</Text>
        {cta && <MessageCta cta={cta} />}
      </GuidanceBox.Content>
    </GuidanceBox>
  );
};
export default MessageGuidanceBox;
